import React from 'react';
import { Hero } from '../../components/go2Legende/Hero';
import { HowItWorks } from '../../components/go2Legende/HowItWorks';
import { LevelsOverview } from '../../components/go2Legende/LevelsOverview';
import { GamificationShowcase } from '../../components/go2Legende/GamificationShowcase';
import { PointsInfo } from '../../components/go2Legende/PointsInfo';
import { ExperienceTeaser } from '../../components/go2Legende/ExperienceTeaser';
import { AchievementsTeaser } from '../../components/go2Legende/AchievementsTeaser';
import { FAQ } from '../../components/go2Legende/FAQ';
import { Link } from 'react-router-dom';

export const LandingPage: React.FC = () => {
  return (
    <div className="bg-white font-sans">
      <Hero />
      <HowItWorks />
      <LevelsOverview />
      <GamificationShowcase />
      <PointsInfo />
      <ExperienceTeaser />
      <AchievementsTeaser />
      <FAQ />

      {/* Final CTA */}
      <section className="py-24 bg-brand-900 text-center px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-6">
            Već si putovao sa Go2?
          </h2>
          <p className="text-xl text-brand-100 mb-10">
            Prijavi se, proveri svoj nivo i vidi koliko ti fali da postaneš Legenda.
          </p>
          <Link 
            to="/go2-legende/dashboard" 
            className="inline-block bg-white text-brand-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-brand-50 transition-colors shadow-lg"
          >
            Prijavi se na Go2 Legende
          </Link>
        </div>
      </section>
    </div>
  );
};
